export default {
  buttons: {
    remove: 'Supprimer',
  },
  title: 'Code promo ou carte cadeau',
};
